import { ComingSoonPublicPage } from '@/components/coming-soon/ComingSoonPublicPage';

export default function ComingSoonPage() {
  return <ComingSoonPublicPage />;
}
